import React from "react";
import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
import { AppThemeProvider } from "@sunrun/experience-ui-components";
import awsconfig from "./aws-exports";
import { App } from "./App";
import { reportWebVitals } from "./reportWebVitals";
import { initFullstory } from "providers/FullStory";
import { initMixpanelTracker } from "providers/mixpanel";

initFullstory();
initMixpanelTracker();
Amplify.configure(awsconfig);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppThemeProvider>
      <App />
    </AppThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
